'use client';

import React, { useState, useEffect, useRef } from 'react';
import { Card, Pagination, Spin, Empty, Flex, Typography, Image } from 'antd';
import SearchSection from './SearchSection';
import useClientFetch from '@/context/hooks/useClientFetch'
import AsyncSection from '@/components/common/AsyncSection'
import { createClientService } from '@/lib/http/client'
import ImageNext from 'next/image';
import { RightOutlined } from '@ant-design/icons';
import { useRouter } from 'nextjs-toploader/app';



export default function WaterfallList({
    initialData,
    initialSearchTerm,
    initialError,
    sysCates = []
}) {

    const router = useRouter();

    const { data, error } = useClientFetch({
        apiName: 'mtop.inventory.i18n.more',
        params: { lang: 'en', pageNum: 1, pageSize: 20, sysCateId: '' },
        initialData,
        initialError,
    })
    if (error) throw error;


    const [isExpand, setIsExpand] = useState(true);


    const [list, setList] = useState(data?.list || []);
    const [loading, setLoading] = useState(false);


    const [pageNo, setPageNo] = useState(1);
    const [page, setPage] = useState(data?.page || { currentPage: 1, totalCount: 0 });

    const [sysCateId, setSysCateId] = useState('');
    const [searchTerm, setSearchTerm] = useState(initialSearchTerm);


    const abortControllerRef = useRef(null);
    const isInitialMount = useRef(true);
    const [requestId, setRequestId] = useState(data?.responseId || '');
    const requestIdRef = useRef(requestId); // 使用 ref 跟踪最新值



    useEffect(() => {
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);

    const fetchData = async () => {

        // 取消之前的请求（如果存在）
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        if (isInitialMount.current) {
            isInitialMount.current = false;
            return; // 首次渲染不执行
        }

        // 创建新的AbortController
        const controller = new AbortController();
        abortControllerRef.current = controller;

        setLoading(true)

        try {
            const res = await createClientService().get(
                'mtop.inventory.i18n.more',
                {
                    data: {
                        lang: 'en',
                        pageNum: pageNo,
                        pageSize: 20,
                        sysCateId,
                        keyword: searchTerm,
                        requestId: requestIdRef.current,
                    },
                    signal: controller.signal
                },
            );

            // 请求完成后清除controller引用
            abortControllerRef.current = null;

            setRequestId(res?.responseId || '');
            setList(res?.list || []);
            setPage(res?.page || { currentPage: 1, totalCount: 0 });

        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('Fetch products error:', error);
                // 这里可以添加错误处理逻辑，例如显示错误信息
            }
        }
        setLoading(false)
    };

    useEffect(() => {
        requestIdRef.current = requestId;
    }, [requestId]);


    useEffect(() => {
        fetchData();
    }, [pageNo, searchTerm, sysCateId]);



    // 处理搜索变化
    const handleSearchChange = (term) => {
        // setSearchTerm(term);

    };

    const handleSearch = (value, event, source) => {
        setSearchTerm(value);
        setPageNo(1); // 重置页码
        fetchData();
    }

    return (
        <div className="waterfall-page">

            <SearchSection
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
                onSearch={handleSearch}
            />

            <div className='waterfall-content'>

                <Flex justify='space-between' className='waterfall_sysCate'>
                    <div className={`sysCate_item_bx`} style={{
                        maxHeight: isExpand ? "70px" : "500px",
                        transition: "max-height 1s ease",
                        overflow: "hidden"
                    }} >
                        {
                            sysCates.map((item, index) => <div className={`sysCate_item ${item.v == sysCateId ? 'active' : ''}`} key={index} onClick={() => { setSysCateId(item.v); setPageNo(1) }}>{item.n}</div>)
                        }
                    </div>

                    <div className={`sysCate_more ${isExpand ? '' : 'collapse'}`} onClick={() => setIsExpand(!isExpand)}>
                        {/* {isExpand ? 'expand' : 'retract'} */}
                        <ImageNext width={26} height={26} alt='more' src='https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/products_stock_more.png' />
                    </div>
                </Flex>

                <Spin spinning={loading}>
                    <AsyncSection className='product_list'>
                        {
                            list.map((item, index) => <div className='product_list_item' key={index}>
                                <Flex align='center' justify='space-between' className='product_list_item_header'>
                                    <Flex align='center' flex={1}>
                                        <ImageNext src={item.shopIcon + '?x-oss-process=image/resize,w_80'} width={72} height={72} className='shop_logo' alt={item.shopName} />
                                        <Flex flex={1} vertical justify='space-around' className='shop_name'>
                                            <Typography.Paragraph ellipsis={{ rows: 2 }}>{item.shopName}</Typography.Paragraph>
                                            <p>{item.publishTime}</p>
                                        </Flex>
                                    </Flex>
                                    <Flex align='center' justify='center' className='btn_view_store' onClick={() => router.push(`/shop/${item.shopId}`)}>View store <RightOutlined /> </Flex>
                                </Flex>
                                <p className='intro'>{item.intro}</p>
                                <Flex align='center' wrap className='stock_img_bx'>
                                    <Image.PreviewGroup>
                                        {
                                            item.pics.map((item, index) => <div className='stock_img_item' key={index}>
                                                <Image
                                                    src={item.p + '?x-oss-process=image/resize,w_150'}
                                                    className='stock_img'
                                                    loading="lazy"
                                                    placeholder={
                                                        <div style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            background: '#f0f0f0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            Loading...
                                                        </div>
                                                    } />
                                            </div>)
                                        }
                                    </Image.PreviewGroup>
                                </Flex>

                                <div className='products_bx'>
                                    {
                                        item.products.map((product, index) => <div className='product_item' key={index}>
                                            <ImageNext src={product.prodPic + '?x-oss-process=image/resize,w_80'} width={80} height={80} className='product_img' alt={product.name} />

                                            <div className='product_info'>
                                                <Typography.Paragraph ellipsis={{ rows: 2 }} className='product_name'>{product.name}</Typography.Paragraph>
                                                <Flex align='center' justify='space-between' className='product_price'>
                                                    <span>{product.priceDisp}</span>
                                                    <em>{product.minQuantity}{product.prodUnit} (MOQ)</em>
                                                </Flex>
                                            </div>
                                        </div>)
                                    }
                                </div>
                            </div>)
                        }
                    </AsyncSection>


                    {list.length > 0 ? <Pagination
                        align="center"
                        pageSize={20}
                        current={pageNo}
                        total={page.totalCount}
                        showSizeChanger={false}
                        onChange={(page) => {
                            setPageNo(page)
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }} /> : <Empty description="No products found" />}
                </Spin>
            </div>
        </div>
    );
}